<!--
  画面名：-
  概要： フローダイアグラム用店舗マニュアルのダイアログを表示するコンポーネント
  備考： タブ切り替えでチェックリストも編集可能
-->

<!-- HTML -->
<template>
  <!--  差し替え・設定変更ダイアログ要素  -->
  <v-dialog class="template-dialog" :class="{operationDialog:isOperation}" v-model="isDialog" max-width="900px">
    <!--  ページ全体を囲う要素  -->
    <div class="dialog-wrapper">
      <v-toolbar flat dense color="white" ref="title">
        <v-layout align-center justify-center row fill-height>
          <v-flex xs4>
            <!-- ページタイトル -->
            <v-card tile flat>
              <v-card-text>
                <div class="dialog-title">
                  <h1>{{ $props.dialogPageTitle }}</h1>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs4>
            <!--
              頻度でフィルタリングするためのドロップダウンリスト
              ダイアログが開閉する度に再描画を行う
            -->
            <v-card tile flat>
              <v-card-text>
                <div class="dropdown-list-left-side-text">
                  <h2>{{ dropdownListLeftSideText }}</h2>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs4>
            <v-card tile flat>
              <v-select
                :key="isDialog"
                v-model="selectedItem"
                @change="updateDropdownListItem"
                :items="selectItems"
                item-text="label"
                item-value="period"
                return-object
                :label="labelItem"
                :disabled="isDisableDropdownList"
                hide-details
                single-line
                outline></v-select>
            </v-card>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-container
      id="scroll-target"
      ref="target"
      >
        <v-layout id="test">
          <!-- 店舗マニュアル一覧 -->
          <TemplateFlowDiagramManualList
            ref="TemplateFlowDiagramManualList"
            :isList="isList"
            :isOperation="isOperation"
            :language="language"
            :configCheckList="configCheckList"
            @setDisabled="setDisabled"
          />
        </v-layout>
        <v-card-actions>
          <v-spacer />
          <!-- 保存ボタン -->
          <!-- 編集時に表示 -->
          <v-btn v-if="!isList && !isOperation" :disabled="isDisabled" small color="blue darken-1" flat @click="flowDiagramSave">{{ language.LabelSave }}</v-btn>
          <!-- 閉じるボタン -->
          <v-btn small color="blue darken-1" flat @click="close">{{ language.LabelClose }}</v-btn>
        </v-card-actions>
      </v-container>
    </div>
    <SaveDialog ref="saveDialog" :msg="errorMessage" @close="close" />
  </v-dialog>
</template>
<!-- /HTML -->

<script>
// 子（外部）コンポーネント読み込み
import TemplateFlowDiagramManualList from '@/components/parts/systemConfig/TemplateFlowDiagramManualList' // 店舗マニュアルコンポーネント
import SaveDialog from '@/components/parts/common/SaveDialog' // 保存完了ダイアログ

export default {
  name: 'TemplateManualInsertUpdateDialog',
  // 親画面からのデータ受け取り
  props: {
    // ページタイトル
    dialogPageTitle: String,
    flowDiagramName: { type: String, default: '' },
    manuals: Array,
    isList: { type: Boolean, default: false },
    isOperation: { type: Boolean, default: false },
    language: Object,
    configCheckList: { type: Object }
  },
  // 子（外部）コンポーネント設定
  components: {
    TemplateFlowDiagramManualList,
    SaveDialog
  },

  // 初期値設定
  data () {
    return {
      // ダイアログの表示切替
      isDialog: false,
      // マニュアル情報を格納
      manualDetail: {},
      // 店舗マニュアルIDを格納
      id: '',
      // フローダイアグラム追加ページ遷移前の状態を保持 0:一般衛生管理
      oldflowDiagramId: 0,
      // 名称セレクトボックスの初期表示
      selectManualId: 0,
      // フローダイアグラムID 0:一般衛生管理 -1:追加 それ以外の数値は各作業ボックスID
      flowDiagramId: 0,
      // エラー用のメッセージを格納
      errorMessage: '',
      // フローダイアグラムID初期値
      flowDiagramDbId: 0,
      // エラー判定
      isDisabled: true,
      // 割り当て用
      setManualIds: [],
      // ドロップダウンリストに用いる頻度の周期とラベルのオブジェクト
      selectItems: [],
      // ドロップダウンリストで選択されたアイテムを格納するオブジェクト
      selectedItem: {},
      // ドロップダウンリストのラベルアイテム
      labelItem: '',
      // ドロップダウンリストの横に表示するためのラベルテキスト
      dropdownListLeftSideText: '',
      // ドロップダウンリストの活性・不活性を制御するフラグ
      isDisableDropdownList: false,
      // 追加用マニュアル情報（TemplateFlowDiagramManualList.getDataを再実行するのに使用する）
      allManuals: [],
      // 変更前の店舗マニュアル情報 一般衛生で使用（TemplateFlowDiagramManualList.getDataを再実行するのに使用する）
      oldManuals: []
    }
  },
  watch: {
    // ダイアログの状態を監視
    isDialog (val) {
      // スクロール
      this.$refs.target.scrollTop = 0
      if (!this.isDialog) {
        this.$refs.TemplateFlowDiagramManualList.clear()
      }
    }
  },
  // コンポーネントの処理を記載
  methods: {
    /**
     * ダイアログ表示処理
     * @param {Array} manuals 表示するマニュアル情報
     * @param {Array} allManuals 追加用マニュアル情報
     * @param {Number} flowDiagramId 0⇒一般衛生 それ以外の数値は作業ボックスID
     * @param {Array} oldManuals 変更前の店舗マニュアル情報 一般衛生で使用
     */
    showDialog (manuals, allManuals, flowDiagramId, oldManuals) {
      this.flowDiagramId = flowDiagramId
      this.isDialog = true

      // ドロップダウンリストが更新された際に使用するために変数に格納
      this.allManuals = allManuals
      this.oldflowDiagramId = oldManuals

      // ドロップダウンリストのラベルアイテムを"全て"で設定
      this.labelItem = this.language.LabelAllMultilingual

      // ドロップダウンリストに表示する頻度の選択肢を生成
      this.selectItems = [
        { 'period': 0, 'label': this.language.LabelAllMultilingual },
        { 'period': 1, 'label': this.language.LabelAnyTimeMultilingual }
      ]

      // 初期状態を選択肢”全て”に設定する
      this.selectedItem = { 'period': 0, 'label': this.language.LabelAllMultilingual }

      // ドロップダウンリスト横に表示するラベルテキストを"頻度"で設定
      this.dropdownListLeftSideText = this.language.LabelFrequencyMultilingual

      // 店舗マニュアルの数が0の場合、または編集時はドロップダウンリストを非活性にする
      this.isDisableDropdownList = (!this.$props.isList && !this.$props.isOperation) || (manuals.length === 0)

      this.$refs.TemplateFlowDiagramManualList.getData(manuals, allManuals, oldManuals, this.selectedItem)
    },
    /**
     * ダイアログ閉じる処理
     */
    close () {
      this.isDialog = false
    },
    /**
    * フローダイアグラムの割り当て実行
    */
    flowDiagramSave () {
      this.setManualIds = []
      for (let manuals of this.$refs.TemplateFlowDiagramManualList.manualList) {
        this.setManualIds.push(manuals.selectManuals)
      }
      // 店舗マニュアルID割り当て追加
      this.$emit('saveManuals', this.flowDiagramId, this.setManualIds)
      // 保存ボタン非表示
      this.isDisabled = true
    },
    /**
     * 店舗マニュアルリストを保存
     */
    setManualList (val) {
      // 初期化
      this.manualList = []
      // チェックリストのテキストが入っているものを抽出
      for (let manual of val) {
        if (manual.text) {
          this.manualList.push(manual)
        }
      }
    },
    // 子コンポーネント初期化
    clear () {
      this.$refs.TemplateFlowDiagramManualList.clear()
    },
    // 保存ボタン表示・非表示設定処理
    setDisabled (isDisabled) {
      this.isDisabled = isDisabled
    },
    /**
     * ドロップダウンリストで値が選択された際のTemplateFlowDiagramManualListの内容変更処理
     */
    updateDropdownListItem () {
      // ドロップダウンリストで"全て"が選択された場合は全て表示する
      // その他の場合は選択された値のperiod値を持つマニュアルだけでフィルタする
      const selectedManuals = (this.selectedItem.label === this.language.LabelAllMultilingual)
        ? this.manuals
        : this.manuals.filter((manual) => {
          if (manual.period === this.selectedItem.period) return true
          return false
        })

      // 子コンポーネントを初期化して再描画する
      this.$refs.TemplateFlowDiagramManualList.clear()
      this.$refs.TemplateFlowDiagramManualList.getData(selectedManuals, this.allManuals, this.oldManuals, this.selectedItem)
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss">
  @import '@/assets/scss/systemConfig/templateFlowDiagramManualDialog.scss';
</style>
